<div class="venture-dropouts-view-part">
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="ventureDropouts()"></grid-content>
</div>